export const getCaceriaAssociations = (caceria) => {
    const parts = caceria.participaciones || [];
    const hunterParts = parts.filter((p) => p.rol?.rol === "CAZADOR");

    const hunters = hunterParts.map((pc) => ({
        hunter: pc.persona,
        arma1: pc.arma1 || null,
        arma2: pc.arma2 || null,
        secretario: pc.secretario || null,
        cargador: pc.cargador || null,
    }));

    return { hunters };
};
